var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import './BulkAddLimitPopover.scss';
import React from 'react';
import { Popover } from 'antd';
export const BulkAddLimitPopover = (_a) => {
    var { children, isDisabled } = _a, rest = __rest(_a, ["children", "isDisabled"]);
    return React.createElement(Popover, Object.assign({ overlayClassName: 'bulk-add-popover disabled-popover', placement: 'bottom', title: 'Too Many Selected', trigger: isDisabled ? [] : 'hover' }, rest),
        React.createElement("span", null, children));
};
